import React from 'react';
import { Button } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';

import NumberInput, { NumberInputProps } from './index';
import styles from './index.module.scss';

const Index: React.FC<NumberInputProps> = (props) => {
  const { value, onChange, disabled } = props;

  // 数值减1
  const handleMinusClick: () => void = () => {
    if (disabled) return;
    const numValue = Number(value) - 1;
    onChange(Number.isNaN(numValue) ? null : `${numValue}`);
  };

  // 数值加1
  const handlePlusClick: () => void = () => {
    if (disabled) return;
    const numValue = Number(value) + 1;
    onChange(Number.isNaN(numValue) ? null : `${numValue}`);
  };

  return (
    <NumberInput
      {...props}
      disabled={disabled}
      className={styles.numberInputWithHandler}
      addonBefore={
        <Button onClick={handleMinusClick} disabled={disabled}>
          <MinusOutlined />
        </Button>
      }
      addonAfter={
        <Button onClick={handlePlusClick} disabled={disabled}>
          <PlusOutlined />
        </Button>
      }
    />
  );
};

export default Index;
